export default {
  ATTACHMENT_PREFIX: "aeonEmbedded://",
  LOCAL_PREFIX: "local://",
  RELATIVE_PREFIX: "relative://",
  FILE_PREFIX: "file://"
};
